"use client"

import { useEffect, useState } from 'react';
import { useIsMobile } from "@/hooks/use-mobile"
import { DataTable } from "@/components/polis/data-table"
import Link from 'next/link'
import { cn } from "@/lib/utils"
import { Button } from "@/components/ui/button"
import {
  IconChevronDown,
  IconChevronLeft,
  IconChevronRight,
  IconChevronsLeft,
  IconChevronsRight,
  IconCircleCheckFilled,
  IconDotsVertical,
  IconGripVertical,
  IconLayoutColumns,
  IconLoader,
  IconPlus,
  IconTrendingUp,
  IconRotateClockwise,
  IconQuestionMark
} from "@tabler/icons-react"
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card"
import {
  Table,
  TableBody,
  TableCaption,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table"
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog"

import { PolisRow } from '@/components/polis/polis-row'
import { CardSmall } from '@/components/polisCard'

export default function Page() {

  type User = {
    FAM: string
    IM: string
    OT: string
    ENP: string
    DATESTART: string
    DATEEND: string
    HREF: string,
    id: string
  }

  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)
  const [init, setInit] = useState('')
  const [infoCell, setInfoCell] = useState('')

  const getZl = () => {
    setLoading(true)
    setInfoCell('Загрузка...')
    let token = localStorage.getItem('token')


    const authData = {
      action: 'zl',
      token: token,
    };

    const options = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(authData)
    };

    fetch('https://lk.kapmed.ru/ini', options)
      .then(response => response.json())
      .then(data => {
        setLoading(false)

        if (data.status == 'false') { setData([]); setInfoCell('Полисы не обнаружены') } else { setData(data); localStorage.setItem('polis', JSON.stringify(data)); }
      })
      .catch(error => {
        setData([])
        setLoading(false)

      });

  }

  useEffect(() => {
    // Пробуем подтянуть из локального хранилища
    let polis = JSON.parse(localStorage.getItem('polis')!)
    if (polis) {
      setData(polis)
    } else {
      getZl()
    }

  }, []);

  const isMobile = useIsMobile()

  return (
    <div className="flex w-full flex-row flex-wrap h-full items-start justify-start  md:p-4 overflow-auto ">
      <div className='max-w-[1920px] mx-auto w-full '>
        {!loading ? (
          <>
          {isMobile ? (
            null
            ) : (
              <Button variant="outline" size="sm" className={isMobile ? ("mx-1"):("mx-6")} onClick={() => getZl()}>
              <IconRotateClockwise />
              <span className="inline">Обновить</span>
            </Button>

            ) }
            
            {isMobile ? (<CardSmall data={data} />) : (<DataTable data={data} infoCell={infoCell} />)}


            <div className="mx-3 my-2">
              <AlertDialog>
                <AlertDialogTrigger asChild>
                  <Button variant="link" className="text-center">Не отображаются полисы детей ?</Button>
                </AlertDialogTrigger>
                <AlertDialogContent>
                  <AlertDialogHeader>
                    <AlertDialogTitle className="text-[#193C6D] mb-4">Не отображаются полисы детей ?</AlertDialogTitle>
                    <AlertDialogDescription className="text-gray-500">
                      Вы можете обратиться в компанию с помощью чата или по круглосуточному бесплатному телефону контакт-центра 8-800-100-81-02. Наши страховые представители проверят информацию и помогут Вам.
                    </AlertDialogDescription>
                  </AlertDialogHeader>
                  <AlertDialogFooter>
                    <AlertDialogAction>Закрыть</AlertDialogAction>
                  </AlertDialogFooter>
                </AlertDialogContent>
              </AlertDialog>
            </div>

          </>
        ) : (
          <>
            {isMobile ? (<div className=" text-center">Загрузка...</div>) : (<DataTable data={[]} infoCell={infoCell} />)}
          </>
        )}

      </div>
    </div>
  )
}
